<div [formGroup]="mainForm">
  <input type="{{type}}" matInput  formControlName="textControlName">

</div>